import { Alert, Flex } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

import { useBlockedChatStore } from "./blockedChat.store";
import styles from "./blockedChatBanner.module.css";

/**
 * Chat build. Closeable banner shown while a voice contact holds the agent non-routable, so new chats
 * aren't arriving (#6973). The SDK's agent-state detector shows it and clears it on recovery; the expert
 * can also dismiss it. Self-contained — it does not touch the Troubleshooting modal.
 */
export function BlockedChatBanner() {
    const isBlocked = useBlockedChatStore((state) => state.isBlocked);
    const setBlocked = useBlockedChatStore((state) => state.setBlocked);
    if (!isBlocked) return null;

    return (
        <Flex className={styles.root}>
            <Alert
                icon={<IconAlertTriangle />}
                color="orange"
                title="You may not be receiving calls and chats"
                classNames={{ root: styles.alert }}
                withCloseButton
                onClose={() => setBlocked(false)}
                w="100%"
            >
                {"If you're not on an active call, click Close contact in Amazon Connect, then refresh Workspace."}
            </Alert>
        </Flex>
    );
}
